import { VARIANT_SKUS } from 'utils/constants/products';
import { LineItem } from 'utils/types';

export const includesCovidDTC = (lineItems: LineItem[] | undefined): boolean =>
  !!lineItems?.some((item) => item.variant_sku === VARIANT_SKUS.COVID);
